import React, { Component, ElementType, ReactNode, ReactChild, ReactFragment, ReactPortal } from 'react';
import classnames from 'classnames';

type TChildren = ElementType | ReactNode | ReactChild | ReactFragment | ReactPortal;

interface IProps {
  classException?: string;
  setIsOpen: (open: boolean) => void;
  rootClass: string;
  isOpen: boolean;
  children: TChildren;
}

class DropDownButton extends Component<IProps> {
  private exceptionSelector = '';

  constructor (props: IProps) {
    super(props);
    this.exceptionSelector = this.props.classException ? this.props.classException : '';
  }

  onOpenHandler = (): void => {
    this.props.setIsOpen(true);
    document.addEventListener('click', this.onCloseHandler);
  };

  onCloseHandler = (event: Event): void => {
    // @ts-ignore
    if(event.target?.parentNode.classList.contains(this.exceptionSelector)) return;
    this.props.setIsOpen(false);
    document.removeEventListener('click', this.onCloseHandler);
  };

  render (): JSX.Element {
    return (
      <button
        onClick={this.onOpenHandler}
        className={classnames(this.props.rootClass, {
          'active': this.props.isOpen })}
      >
        {this.props.children}
      </button>
    );
  }
}

export default DropDownButton;
